import { TranslationMessages } from './en';

const vietnameseMessages: TranslationMessages = {
  feedback: {
    title: 'Phản hồi Neko Coffee',
    subtitle: 'Giúp chúng mình cải thiện trải nghiệm quán cà phê của bạn',
    rating: {
      label: 'Bạn đánh giá trải nghiệm của mình như thế nào?',
    },
    platform: {
      label: 'Nền tảng',
      dineIn: 'Dùng tại quán',
      delivery: 'Giao hàng',
      grab: 'Grab',
      shopeeFood: 'Shopee Food',
      xanhSM: 'Xanh SM',
    },
    category: {
      label: 'Danh mục',
      foodBeverage: 'Chất lượng Đồ ăn & Thức uống',
      service: 'Trải nghiệm Dịch vụ',
      atmosphere: 'Không gian & Bầu không khí',
      menu: 'Đề xuất Thực đơn',
      staff: 'Phản hồi về Nhân viên',
      general: 'Phản hồi Chung',
      other: 'Khác',
    },
    contact: {
      title: 'Kênh Liên hệ Khác',
      facebook: 'Facebook Fanpage',
      zalo: 'Zalo',
      hotline: 'Hotline',
      email: 'Email',
      youtube: 'YouTube',
      googleMaps: 'Google Maps',
    },
    orderId: {
      label: 'Mã Đơn Hàng',
      grabFormat: 'ví dụ: GF-12345 hoặc Booking ID dài hơn',
      placeholder: {
        grab: 'Nhập mã đơn hàng Grab của bạn (GF-12345 hoặc Booking ID)',
        'shopee-food': 'Nhập mã đơn hàng ShopeeFood của bạn',
        'xanh-sm': 'Nhập mã đơn hàng Xanh SM của bạn',
      },
      hint: {
        grab: 'Bạn có thể sử dụng định dạng ngắn (GF-xx) hoặc Booking ID dài hơn. Tìm trong ứng dụng Grab hoặc email xác nhận',
        'shopee-food':
          'Bạn có thể tìm mã đơn hàng trong ứng dụng ShopeeFood hoặc email xác nhận',
        'xanh-sm':
          'Bạn có thể tìm mã đơn hàng trong ứng dụng Xanh SM hoặc email xác nhận',
      },
    },
    comment: {
      label: 'Phản hồi của bạn',
      placeholder:
        'Chúng mình rất muốn lắng nghe bạn! 💬 Hãy chia sẻ những điều bạn yêu thích, những gì chúng mình có thể cải thiện, hoặc bất kỳ gợi ý nào để lần tới bạn đến sẽ tuyệt vời hơn...',
    },
    contactInfo: {
      label: 'Thông tin liên hệ (SĐT/Zalo - Tùy chọn)',
      placeholder: 'Nhập số điện thoại hoặc Zalo để chúng mình có thể phản hồi cho bạn',
    },
    images: {
      label: 'Ảnh (Tùy chọn)',
      upload: 'Thêm Ảnh',
      hint: 'Bạn có thể tải lên tối đa 5 ảnh (mỗi ảnh tối đa 5MB)',
      maxReached: 'Tối đa 5 ảnh được phép',
      tooLarge: 'Ảnh quá lớn. Kích thước tối đa là 5MB',
      invalidType: 'Vui lòng tải lên file ảnh',
    },
    submit: 'Gửi Phản hồi',
    success: {
      title: 'Cảm ơn bạn!',
      message: 'Phản hồi của bạn đã được gửi thành công.',
      ratingMessage: {
        1: 'Chúng mình rất tiếc vì trải nghiệm của bạn chưa được trọn vẹn. Phản hồi của bạn là động lực để tụi mình cải thiện và làm tốt hơn trong những lần tới.',
        2: 'Cảm ơn bạn đã dành thời gian chia sẻ. Chúng mình rất trân trọng phản hồi này và sẽ dùng nó để không ngừng cải thiện dịch vụ.',
        3: 'Cảm ơn bạn đã phản hồi! Chúng mình rất vui vì bạn đã ghé thăm và sẽ tiếp tục cố gắng để mang đến cho bạn những trải nghiệm tốt hơn nữa.',
        4: 'Cảm ơn bạn rất nhiều! Chúng mình rất vui khi biết bạn đã có trải nghiệm tuyệt vời trong đơn hàng vừa rồi và tụi mình sẽ luôn nỗ lực không ngừng để mang đến những trải nghiệm còn tuyệt vời hơn nữa trong tương lai.',
        5: 'Wow, cảm ơn bạn nhiều lắm! 🌟 Chúng mình rất vui khi biết bạn đã yêu thích trải nghiệm tại đây. Những lời động viên của bạn thật sự là nguồn động lực lớn cho tụi mình 💛',
      },
    },
    thankYou: {
      backToForm: 'Gửi Phản hồi Khác',
    },
  },
};

export default vietnameseMessages;
